// src/utils/filter.js

// ✅ Grunnleggende ordfilter (brukt i gamle deler eller bredere bruk)
const forbudteOrd = [
    'fuck', 'shit', 'idiot', 'dritt', 'sex', 'nazi', 'terror', 'hore', 'drugs', 'negger', 'fitte' ,
    'kode-essens@hotmail.com', 'admin', 'Adam-QK', 'Kohdamani', 'passord'
  ];
  
  export function erInnholdGyldig(tekst) {
    const lavereTekst = tekst.toLowerCase();
    return !forbudteOrd.some((ord) => lavereTekst.includes(ord));
  }
  
  // ✅ Spesifikk validator for Kode-Essens™-feltene
  export function validateEssensInput(input) {
    const spesielleTegn = /[<>{}[\];:]/;
  
    if (!input.trim()) {
      return '❌ Du må skrive noe.';
    }
  
    if (!erInnholdGyldig(input)) {
      return '❌ Dette innholdet er ikke tillatt.';
    }
  
    if (spesielleTegn.test(input)) {
      return '❌ Ugyldige tegn er brukt.';
    }
  
    if (input.length > 100) {
      return '❌ Teksten er for lang.';
    }
  
    return ''; // Alt OK
  }
  